import _classCallCheck from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\NETINDO\\web\\alfar\\npos-bo-alfar\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { Base } from './Base.js';
import { Number as NumberT } from './Number.js';
import * as utils from './utils.js';
var ArrayT = /*#__PURE__*/function (_Base) {
  _inherits(ArrayT, _Base);
  function ArrayT(type, length) {
    var _this;
    var lengthType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'count';
    _classCallCheck(this, ArrayT);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ArrayT).call(this));
    _this.type = type;
    _this.length = length;
    _this.lengthType = lengthType;
    return _this;
  }
  _createClass(ArrayT, [{
    key: "decode",
    value: function decode(stream, parent) {
      var length;
      var pos = stream.pos;
      var res = [];
      var ctx = parent;
      if (this.length != null) {
        length = utils.resolveLength(this.length, stream, parent);
      }
      if (this.length instanceof NumberT) {
        // define hidden properties
        Object.defineProperties(res, {
          parent: {
            value: parent
          },
          _startOffset: {
            value: pos
          },
          _currentOffset: {
            value: 0,
            writable: true
          },
          _length: {
            value: length
          }
        });
        ctx = res;
      }
      if (length == null || this.lengthType === 'bytes') {
        var target = length != null ? stream.pos + length : (parent != null ? parent._length : undefined) ? parent._startOffset + parent._length : stream.length;
        while (stream.pos < target) {
          res.push(this.type.decode(stream, ctx));
        }
      } else {
        for (var i = 0, end = length; i < end; i++) {
          res.push(this.type.decode(stream, ctx));
        }
      }
      return res;
    }
  }, {
    key: "size",
    value: function size(array, ctx) {
      var includePointers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      if (!array) {
        return this.type.size(null, ctx) * utils.resolveLength(this.length, null, ctx);
      }
      var size = 0;
      if (this.length instanceof NumberT) {
        size += this.length.size();
        ctx = {
          parent: ctx,
          pointerSize: 0
        };
      }
      var _iterator = _createForOfIteratorHelper(array),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          size += this.type.size(item, ctx);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (ctx && includePointers && this.length instanceof NumberT) {
        size += ctx.pointerSize;
      }
      return size;
    }
  }, {
    key: "encode",
    value: function encode(stream, array, parent) {
      var ctx = parent;
      if (this.length instanceof NumberT) {
        ctx = {
          pointers: [],
          startOffset: stream.pos,
          parent: parent
        };
        ctx.pointerOffset = stream.pos + this.size(array, ctx, false);
        this.length.encode(stream, array.length);
      }
      var _iterator2 = _createForOfIteratorHelper(array),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          this.type.encode(stream, item, ctx);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (this.length instanceof NumberT) {
        var i = 0;
        while (i < ctx.pointers.length) {
          var ptr = ctx.pointers[i++];
          ptr.type.encode(stream, ptr.val, ptr.parent);
        }
      }
    }
  }]);
  return ArrayT;
}(Base);
export { ArrayT as Array };